/*eslint-disable*/ module.exports = {
  messages: {
    Active: 'Attivi',
    Add: 'Aggiungi',
    'Add New dish': 'Aggiungi nuovo articolo',
    'Add New item': 'Aggiungi nuovo elemento',
    'Add Picture': 'Aggiungi immagine',
    'Add QR code': 'Aggiungi codice QR',
    'Add category or element': 'Aggiungi categoria o elemento',
    'Add dish': 'Aggiungi articolo',
    'Add new menu': 'Aggiungi nuovo menù',
    'After creating a category, you can add dishes.':
      'Dopo aver creato una categoria, è possibile aggiungere piatti.',
    All: 'Tutti',
    'All languages': 'Tutte le lingue',
    Allergens: 'Allergeni',
    'Are you sure you want to delete this menu?':
      'Sei sicuro di voler eliminare questo menù?',
    'Back to Food Menu': 'Torna',
    'Beer servings': 'Formati di birra',
    Bottom: 'Inferiore',
    'Brand elements': 'Elementi del brand',
    Cancel: 'Annulla',
    Categories: 'Categorie',
    'Create Text Block': 'Crea blocco di testo',
    Currency: 'Valuta',
    'Daily Menu': 'Menù del giorno',
    'Daily menu': 'Menù del giorno',
    Data: 'Dati',
    'Data & Elements': 'Dati & Elementi',
    Delete: 'Elimina',
    'Delete menu': 'Elimina menù',
    'Delete page break': 'Elimina interruzione di pagina',
    Description: 'Descrizione',
    'Description (Optional)': 'Descrizione (facoltativo)',
    Designs: 'Design',
    Duplicate: 'Duplica',
    'Duplicate menu': 'Duplica menù',
    Edit: 'Modifica',
    'Edit Picture': 'Modifica immagine',
    'Edit QR code': 'Modifica codice QR',
    'Edit Text Block': 'Modifica blocco di testo',
    'Edit dish': 'Modifica articolo',
    'Edit Colored Star Of The Crafters': 'Edit The Brewers Star',
    Elements: 'Elementi',
    'Error!': 'Errore!',
    Export: 'Esporta',
    'Export XML': 'Esporta XML',
    'Export PDF': 'Esporta PDF',
    'Food cards & Specials': 'Menù & Specialità',
    'Food image': 'Immagine del cibo',
    'Generate QR code': 'Genera codice QR',
    Grid: 'Griglia',
    'Hover over the tab area to see options for adding categories and elements.':
      "Passa il mouse sopra l'area delle schede per vedere le opzioni per aggiungere categorie ed elementi.",
    'Hviezda sladkov': 'The Brewers Star - BW',
    'Farebna hviezda sladkov': 'The Brewers Star - color',
    Inline: 'In linea',
    List: 'Lista',
    Logo: 'Logo',
    'Move Block': 'Sposta blocco',
    'Move after block': 'Sposta dopo il blocco',
    'Move block position': 'Sposta posizione blocco',
    'Move to beginning': "Sposta all'inizio",
    'Name of Restaurant': 'Nome del ristorante',
    'Name of category': 'Nome della categoria',
    Next: 'Successivo',
    'No menus were found. Please try to change filters.':
      'Nessun menu trovato. Prova a cambiare i filtri.',
    'One column': 'Una colonna',
    'One column with image': 'Una colonna con immagine',
    Others: 'Altri',
    'Page break': 'Interruzione di pagina',
    Picture: 'Immagine',
    Position: 'Posizione',
    Price: 'Prezzo',
    Primary: 'Primario',
    'Secondary Primary': 'Principale',
    Print: 'Stampa',
    'QR code': 'Codice QR',
    'Recommend a drink': 'Consiglia una bevanda',
    Remove: 'Rimuovi',
    'Remove category': 'Rimuovi categoria',
    'Remove dish': 'Rimuovi articolo',
    'Required field': 'Campo obbligatorio',
    Save: 'Salva',
    'Select allergens': 'Seleziona allergeni',
    'Set to active': 'Imposta come attivo',
    'Set to inactive': 'Imposta come inattivo',
    Settings: 'Impostazioni',
    Share: 'Condividi',
    'Share on FB': 'Condividi su FB',
    'Copy menu link': 'Copiare il link del menu',
    'Show Allergens': 'Mostra allergeni',
    'Show Title Page': 'Mostra pagina del titolo',
    'Show info': 'Mostra informazioni',
    'Show name of Restaurant': 'Mostra il nome del ristorante',
    'Show text': 'Mostra testo',
    'Show weight / bulk / pieces': 'Mostra peso / quantità / pezzi',
    Size: 'Dimensione',
    'Secondary Size': 'Formato',
    Templates: 'Modelli',
    'Text block': 'Blocco di testo',
    'Tips & Tricks': 'Consigli & Trucchi',
    Title: 'Titolo',
    'Two columns': 'Due colonne',
    'Two columns with image': 'Due colonne con immagine',
    'Type or choose category': 'Digita o scegli la categoria',
    'Type or choose dish': 'Digita o scegli il articolo',
    'URL address': 'Indirizzo URL',
    Untitled: 'Senza titolo',
    'Upload image': 'Carica immagine',
    'Weight / bulk / pcs': 'peso / quantità / pezzi',
    add: 'aggiungi',
    description: 'descrizione',
    languange: 'lingua',
    logo: 'logo',
    'remove page': 'rimuovi pagina',
    units: 'unità',
    '{0}': [['0']],
    '{label}': [['etichetta']],
    'Add Beer Servings': 'Aggiungi porzioni di birra',
    'Add New item': 'Aggiungi un nuovo elemento',
    'Add Star Of The Crafters': 'Add The Brewers Star - BW',
    'Add Colored Star Of The Crafters': 'Add The Brewers Star - color',
    'Add meal': 'Aggiungi',
    'Add other': 'Aggiungi Bevande',
    'Add soup': 'Aggiungi la zuppa',
    Amount: 'Prezzo',
    'Are you sure you want to delete this daily menu?':
      'Sei sicuro di voler eliminare questo menù giornaliero?',
    'Available only for A4 size': 'Disponibile solo per il formato A4',
    'Back to Daily Menu': 'Torna',
    'Click to select a date': 'Fare clic per selezionare una data',
    Close: 'Chiudi',
    Continue: 'Continua',
    'Copy menu': 'Copia menù',
    Desserts: 'Dolci',
    Displays: 'Visualizza',
    'Double Image Block': 'Blocco con doppia immagine',
    'Edit Beer Servings': 'Edit Beer Servings',
    'Edit Star Of The Crafters': 'Edit The Brewers Star - BW',
    'Edit Colored Star Of The Crafters': 'Edit The Brewers Star - color',
    Email: 'Email',
    'Export as JPG': 'Esporta come JPG',
    'Fill in your contact information and we will reach back to you:':
      'Fill in your contact information and we will reach back to you:',
    'Jsme hrdí držitelé hvězdy sládku 2020':
      'Jsme hrdí držitelé hvězdy sládku 2020',
    Language: 'Lingua',
    'Logo {0}': ['Logo ', ['0']],
    Meals: 'Cibo',
    Menu: 'Menù',
    'Secondary Menu': 'Cibo',
    'Move Dish': 'Sposta articolo',
    'Move Dish position': 'Sposta la posizione dell’articolo',
    'Move after dish': 'Sposta dopo articolo',
    Name: 'Nome',
    'No daily menus were found. Please try to change filters.':
      'Non sono stati trovati menù giornalieri. Si prega di provare a cambiare i filtri.',
    'Ocenění za nejlepší peči o čepované pivo':
      'Ocenění za nejlepší peči o čepované pivo',
    'Order Print': 'Order Print',
    'Order print': 'Order print',
    Other: 'Altro',
    'Secondary Other': 'Bevande',
    Phone: 'Telefono',
    Preview: 'Anteprima',
    'Price with soup': 'Prezzo con zuppa',
    'Price with meal': 'Prezzo con cibo',
    'Price with soup and meal': 'Prezzo con zuppa e articolo',
    'Show portion size': 'Mostra la dimensione della porzione',
    Soup: 'Zuppa',
    'Soup can be orderer separately':
      'La zuppa può essere ordinata separatamente',
    'Soup priced in main dish': 'Zuppa inclusa nel articolo principale',
    Soups: 'Zuppa',
    Submit: 'Salva',
    'We do not offer anything for this day':
      'Non offriamo nulla per questo giorno',
    'We do not offer:': 'Non offriamo:',
    'Weight / bulk / pieces': 'peso / quantità / pezzi',
    'You might loose some layout settings by this change. Do you wish to continue?':
      'Potresti perdere alcune impostazioni di layout a causa di questa modifica. Vuoi continuare?',
    'Známky kvalitně načepovaného piva': 'Známky kvalitně načepovaného piva',
    'category/element': 'categoria/elemento',
    item: 'articolo',
    language: 'lingua',
    'Beer Selection': 'Carta delle birre',
    'Add Beer Selection': 'Aggiungi Carta delle birre',
    'size in cl': 'volume in cl',
    'size in ml': 'volume in ml',
    'Alcohol Content': 'Contenuto Alcolico',
    Color: 'Colore',
    'Country Of Origin': 'Paese di Origine',
    Fermentation: 'Fermentazione',
    'Food Combinations': 'Abbinamenti Alimentari',
    'Serving Temperature': 'Temperatura di Servizio',
    Taste: 'Sapore',
    'Logo (Not available)': 'Logo (non presente)',
    "Can't upload image": "Impossibile caricare l'immagine",
    'Description not available': 'Descrizione non disponibile',
    'Edit Beer Selection': 'Modifica la carta delle birre',
    'Title is required': 'Titolo richiesto',
    PageBreakBlock: 'Interruzione di pagina',
    'Select beers': 'Seleziona birre',
    'Beer Type': 'Stile',
    'Mandatory field': 'Campo obbligatorio',
    Image: 'Image',
    'not available': 'non presente',
    'Copied successfully!': 'Copiato con successo!',
    'Error copied!': 'Errore nella copia!',
    'Separate price for each item':
      'Prezzo separato per zuppa e articolo principale',
    'Soup price is included in the menu':
      'Il prezzo della zuppa è incluso nel menù',
    'Different price for the whole menu': 'Prezzo diverso per l’intero menù',
    'Responsibility Message': 'Messaggio di responsabilità',
    'ID:': 'ID',
    'Please complete the first 2 steps': 'Completa i primi 2 passaggi',
    'Image generation in progress. Please wait. When the download is complete, return to the list of daily menus.':
      "Generazione dell'immagine in corso. Si prega di attendere. Quando il download è completo, torna alla lista dei menù giornalieri.",
    'Are you sure you want to delete this category?':
      'Sei sicuro di voler eliminare questa categoria?',
    Yes: 'Sì',
    No: 'No',
    'Delete item': 'Elimina articolo',
    'Edit element': 'Modifica elemento',
    'Write a name': 'Scrivi un nome',
    'Create category': 'Crea categoria',
    'Edit category': 'Modifica categoria',
    'Delete category': 'Elimina categoria',
    'Choose a category': 'Scegli una categoria',
    Custom: 'Personalizzato',
    'Add item': 'Aggiungi articolo',
    'Add category': 'Aggiungi categoria',
    'This category already exists.': 'Questa categoria esiste già.',
    'Something went wrong, probably your file exceeds the allowed post-processing size 10Mb. Please try again with a smaller file.':
      'Qualcosa è andato storto, probabilmente il tuo file supera la dimensione massima di elaborazione post 10Mb. Riprova con un file più piccolo.',
    'The uploaded file exceeds the maximum allowed size of 10MB. Please upload a smaller file.':
      'Il file caricato supera la dimensione massima consentita di 10MB. Carica un file più piccolo.',
    Warning: 'Attenzione',
    'You might loose some layout settings by this change. Do you wish to continue?':
      'Potresti perdere alcune impostazioni di layout a causa di questa modifica. Vuoi continuare?',
    'Bottom description': 'Descrizione in basso',
    'Logo size': 'Dimensione del logo',
    Small: 'Piccolo',
    Medium: 'Medio',
    Large: 'Grande',
  },
}
